export default __webpack_public_path__ + "static/media/TasCreateAccountScreen.b3591c4b.gif";